import { Segment, Statistic } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";

import money from "astrid-helpers/src/money";
import { getCostColor } from "astrid-web/src/features/costs/utils/costColors";

export default function CostBalance({ totalExpenseAmount, totalRevenueAmount, currency }) {
	const { t } = useTranslation();

	const grossProfit = totalRevenueAmount - totalExpenseAmount;
	const grossMargin = (grossProfit / totalRevenueAmount) * 100;

	return (
		<Segment padded>
			<Statistic.Group size="mini" widths="4" style={{ fontSize: 12 }}>
				<Statistic>
					<Statistic.Label>{t("expenses", "Expenses")}</Statistic.Label>
					<Statistic.Value>
						<div style={{ fontSize: 18 }}>{money(totalExpenseAmount, currency)}</div>
					</Statistic.Value>
				</Statistic>

				<Statistic>
					<Statistic.Label>{t("revenues", "Revenues")}</Statistic.Label>
					<Statistic.Value>
						<div style={{ fontSize: 18 }}>{money(totalRevenueAmount, currency)}</div>
					</Statistic.Value>
				</Statistic>

				<Statistic color={getCostColor(grossProfit)}>
					<Statistic.Label>{t("grossProfit", "Gross profit")}</Statistic.Label>
					<Statistic.Value>
						<div style={{ fontSize: 18 }}>{money(grossProfit, currency)}</div>
					</Statistic.Value>
				</Statistic>

				<Statistic color={getCostColor(grossMargin)}>
					<Statistic.Label>{t("grossMargin", "Gross margin")}</Statistic.Label>
					<Statistic.Value>
						<div style={{ fontSize: 18 }}>{money(grossMargin, null)} %</div>
					</Statistic.Value>
				</Statistic>
			</Statistic.Group>
		</Segment>
	);
}
